












































import 'reflect-metadata'
import { Component, Vue } from 'vue-property-decorator'
import dayjs from 'dayjs'

@Component
export default class DataTableReport extends Vue {

	headers = [
		{ text: "No", rowspan:"2", value: "no", width: 30 ,sortable: false, align: "center fix-column-no" },
		{ text: "ยูนิต", rowspan:"2", value: "unitCode", width: 150 ,sortable: false, align: "center fix-column-unit" },
		{ text: "PJ Plan Date", rowspan:"2", value: "planPJDate", width: 150 ,sortable: false, align: "center" },
		{ text: "ครั้งที่", rowspan:"2",value: "insNumber", width: 150 ,sortable: false, align: "center" },
		{ text: "สถานะการเก็บงาน", value: "finishPJStatus", width: 150 ,sortable: false, align: "center" },
		{ text: "วันที่ CR นัดได้", value: "planCRDate", width: 180 ,sortable: false, PlanCRDatealign: "center" },
		{ text: "เวลาที่นัดได้", value: "planCRTime", width: 150 ,sortable: false, align: "center" },
		{ text: "ชื่อบริษัทรับตรวจบ้าน", value: "inspectorName", width: 300 ,sortable: false, align: "center" },
		{ text: "วันโอนกรรมสิทธิ์จริง", value: "activityDate", width: 150 ,sortable: false, align: "center" },
		{ text: "Name", value: "customerName", width: 150 ,sortable: false, align: "start" },
		{ text: "Mobile No.", value: "mobilePhone", sortable: false, align: "start" },
		{ text: "บ้านเลขที่	", value: "address", sortable: false, align: "start" },
		{ text: "CR Name", value: "crName", sortable: false, align: "start" },
		{ text: "วันที่ PJ Plan ให้ CR ออกจดหมาย1", value: "letterDate" ,sortable: false, align: "center" },
		{ text: "CR Note", value: "crNote", width: 300 ,sortable: false, align: "center" },
		{ text: "PJ Note", value: "pjNote", width: 300 ,sortable: false, align: "center" },
	]
	
	selected = [] as any[]
	tableData = [] as any[]

	setTableData (reportInspectionPlanning: any[]) {
		this.tableData = reportInspectionPlanning.map((x, i) => {
			x.no = i+1
			x.planPJDate = x.planPJDate != "" ? dayjs(x.planPJDate).format("DD/MM/YYYY") : ""
			x.planCRDate = x.planCRDate != "" ? dayjs(x.planCRDate).format("DD/MM/YYYY") : ""
			x.activityDate = x.activityDate != "" ? dayjs(x.activityDate).format("DD/MM/YYYY") : ""
			x.letterDate = x.letterDate != "" ? dayjs(x.letterDate).format("DD/MM/YYYY") : ""
			return x
		})
	}

	clearDataTable () {
		this.tableData = []
	}
}

